import { darken, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  searchInput: {
    marginBottom: 12
  },

  skeleton: {
    width: '30%'
  },
  templateContainer: {
    display: 'grid',
    gridTemplateColumns: 'auto',
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: 'auto auto'
    },
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: 'auto auto auto'
    },
    rowGap: 12,
    columnGap: 6
  },
  templateItem: {
    paddingTop: 12,
    paddingBottom: 12,
    backgroundColor:
      theme.palette.type === 'dark'
        ? darken(theme.palette.background.default, 0.3)
        : '#f3f3f3',
    borderRadius: 12,
    cursor: 'pointer',
    border: `2px solid ${theme.palette.background.default}`,
    transition: 'all 0.25s linear',
    position: 'relative',
    height: 'fit-content',
    minHeight: 120,
    display: 'flex',
    justifyContent: 'center'
  },
  activeTemplateItem: {
    backgroundColor: theme.palette.background.default,
    border: `2px solid ${theme.palette.primary.main}`
  },
  activeCircle: {
    position: 'absolute',
    top: 10,
    right: 10,
    width: 12,
    height: 12,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main
  },
  tenantInput: {
    // not working!
    backgroundColor: 'red important!'
  },
  buttonsPositionSolver: {
    width: '100%',
    height: '42vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  noDataInfoContainer: {
    textAlign: 'center'
  },
  noDataInfo: {
    marginBottom: 10
  },
  createTemplateButton: {
    borderRadius: 0,
    position: 'relative',
    // borderBottom: `1px solid ${theme.palette.primary.main}`,
    '&:hover': {
      backgroundColor: 'transparent'
    },
    '&::after': {
      position: 'absolute',
      top: '85%',
      right: 7,
      content: `''`,
      paddingTop: '10',
      width: '75%',
      height: 2,
      backgroundColor: theme.palette.primary.main
    }
  },
  createTemplateLinkContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'end',
    marginTop: 50
    // backgroundColor: 'green'
  },
  createTemplateIcon: {
    marginRight: 4,
    fontSize: '1.5rem',
    alignSelf: 'start'
  },
  createTemplateLink: {
    // backgroundColor: 'blue',
    marginBottom: 0
  }
}))

export default useStyles
